var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineStore } from 'pinia';
import api from '../modules/axios';
import { useAuthorizationStore } from './authorization';
import { useProfileStore } from './profile';
import Cookies from 'js-cookie';
export var useAuthStore = defineStore('auth', {
    state: function () { return ({
        token: '',
        tokenExp: null,
        isConfirmedUser: false,
        isCheckRT: false,
        isLogin: false,
    }); },
    getters: {
        isAuth: function (state) {
            return !!state.token && state.isConfirmedUser;
        },
        loginFlag: function (state) {
            return state.isLogin;
        },
        isRG: function (state) {
            return state.isCheckRT;
        },
    },
    actions: {
        setLoginFlag: function () {
            this.isLogin = true;
        },
        resetLoginFlag: function () {
            this.isLogin = false;
        },
        setConfirmUser: function (confirm) {
            this.isConfirmedUser = confirm;
        },
        signIn: function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var authorization, result, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            authorization = useAuthorizationStore();
                            this.isCheckRT = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.post('/user/sign_in', {
                                    email: payload.email,
                                    password: payload.password,
                                })];
                        case 2:
                            result = _a.sent();
                            if (result.data.api_token) {
                                this.token = String(result.data.api_token);
                                sessionStorage.setItem('tkn', result.data.api_token);
                                authorization.setAuthorize(result.data.api_token);
                                this.isConfirmedUser = true;
                                this.isLogin = true;
                            } /*
                            if(result.data.refresh_token) {
                              const option = {
                                path: '/',
                                maxAge: 60 * 60 * 24 * 30,
                              }
                              Cookies.set('refresh_token', result.data.refresh_token, option)
                            } */
                            return [2 /*return*/, result];
                        case 3:
                            err_1 = _a.sent();
                            return [2 /*return*/, err_1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        signUp: function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var result, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.isCheckRT = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.post('/user/sign_up', {
                                    email: payload.email,
                                    password: payload.password,
                                })];
                        case 2:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 3:
                            err_2 = _a.sent();
                            return [2 /*return*/, err_2];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        oauth: function (provider) {
            return __awaiter(this, void 0, void 0, function () {
                var result, err_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.isCheckRT = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.get("/provider/".concat(provider, "/sign"))];
                        case 2:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 3:
                            err_3 = _a.sent();
                            return [2 /*return*/, err_3];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        signInWithSns: function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var authorization, result, err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            authorization = useAuthorizationStore();
                            this.isCheckRT = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.post("/provider/".concat(payload.provider, "/sign"), {
                                    code: payload.code,
                                })];
                        case 2:
                            result = _a.sent();
                            if (result.data.api_token) {
                                this.token = String(result.data.api_token);
                                sessionStorage.setItem('tkn', result.data.api_token);
                                authorization.setAuthorize(result.data.api_token);
                                this.isConfirmedUser = true;
                                this.isLogin = true;
                            } /*
                            if(result.data.refresh_token) {
                              const option = {
                                path: '/',
                                maxAge: 60 * 60 * 24 * 30,
                              }
                              Cookies.set('refresh_token', result.data.refresh_token, option)
                            } */
                            return [2 /*return*/, result];
                        case 3:
                            err_4 = _a.sent();
                            return [2 /*return*/, err_4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        confirmation: function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var authorization, result, err_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            authorization = useAuthorizationStore();
                            this.isCheckRT = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.post('/user/confirmation', {
                                    name: payload.name,
                                    customer_id: payload.cid,
                                    password: payload.password,
                                }, {
                                    headers: {
                                        'confirmation-token': payload.token,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            this.token = String(result.data.api_token);
                            authorization.setAuthorize(result.data.api_token);
                            this.isLogin = true;
                            return [2 /*return*/, result];
                        case 3:
                            err_5 = _a.sent();
                            return [2 /*return*/, err_5];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        regenerateToken: function () {
            return __awaiter(this, void 0, void 0, function () {
                var authorization, profileStore, result, err_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            authorization = useAuthorizationStore();
                            profileStore = useProfileStore();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.put('/user/token')];
                        case 2:
                            result = _a.sent();
                            if (result.data.access_token) {
                                this.token = result.data.access_token;
                                this.isCheckRT = true;
                                sessionStorage.setItem('tkn', result.data.access_token);
                                authorization.setAuthorize(result.data.access_token);
                            }
                            else {
                                if (this.token) {
                                    Object.assign(this.$state, {
                                        token: '',
                                        tokenExp: null,
                                        isConfirmedUser: false,
                                        isCheckRT: false,
                                    });
                                    profileStore.resetUserProfile();
                                    authorization.resetAuthorize();
                                    alert('ログインの有効期限が切れました');
                                }
                                sessionStorage.removeItem('tkn');
                            }
                            return [2 /*return*/, result];
                        case 3:
                            err_6 = _a.sent();
                            this.isCheckRT = true;
                            return [2 /*return*/, err_6];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        resetToken: function () {
            return __awaiter(this, void 0, void 0, function () {
                var authorization, profileStore, res, err_7;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            authorization = useAuthorizationStore();
                            profileStore = useProfileStore();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.put('/user/token')];
                        case 2:
                            res = _a.sent();
                            if (res.data.access_token) {
                                this.token = res.data.access_token;
                                sessionStorage.setItem('tkn', res.data.access_token);
                                authorization.setAuthorize(res.data.access_token);
                            }
                            else if (res.data.message) {
                                sessionStorage.removeItem('tkn');
                                Object.assign(this.$state, {
                                    token: '',
                                    tokenExp: null,
                                    isConfirmedUser: false,
                                    isCheckRT: false,
                                });
                                profileStore.resetUserProfile();
                                authorization.resetAuthorize();
                                alert('ログインの有効期限が切れました');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            err_7 = _a.sent();
                            sessionStorage.removeItem('tkn');
                            Object.assign(this.$state, {
                                token: '',
                                tokenExp: null,
                                isConfirmedUser: false,
                                isCheckRT: false,
                            });
                            profileStore.resetUserProfile();
                            authorization.resetAuthorize();
                            alert('ログインの有効期限が切れました');
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        logout: function () {
            return __awaiter(this, void 0, void 0, function () {
                var result, err_8;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, api.delete('/user/sign_out')];
                        case 1:
                            result = _a.sent();
                            sessionStorage.removeItem('tkn');
                            Cookies.remove('refresh_token');
                            return [2 /*return*/, result];
                        case 2:
                            err_8 = _a.sent();
                            return [2 /*return*/, err_8];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
    },
    persist: true,
});
